import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, AlertController, ToastController, Tabs } from 'ionic-angular';
import { Items } from '../../providers/providers';
import { Questions } from '../../models/questions';
/**
 * Generated class for the AdministerPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage({
  name: 'administer',
  segment: 'administer',
})
@Component({
  selector: 'page-administer',
  templateUrl: 'administer.html',
})
export class AdministerPage {
  clientName: string = this.navParams.get('clientName');
  clientId: string = this.navParams.get('clientId');
  is_parent_2: string = this.navParams.get('is_parent_2');
  // pageName: string = this.navParams.get('pageName');
  assessmentsArray = [] = this.navParams.get('assessments');
  uniqueId: string = this.navParams.get('uId');
  index: number = this.navParams.get('index');
  isSchedule: boolean = this.navParams.get('isSchedule');
  isEmailResultToClient: string = this.navParams.get('isEmailResultToClient')
  questions = [];
  tempQues: Questions[];
  questionsArray = [];
  isenabled: boolean;
  assessmentName: string;
  index_: number = 0;
  assessmentCompleted: boolean;
  numberOfAssessments: number;
  reportsArray : Array<{report_url : string , assessmentName : string}> = [];
  // isFirstAssessment: boolean;

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController,
    public items: Items, public alertCtrl: AlertController, public toastCtrl: ToastController) {
    this.isenabled = false;
    // this.index = this.navParams.get('index');
    if (this.navParams.get('isSchedule')) {
      this.isSchedule = true;
      this.reportsArray = this.navParams.get('reports')
      this.isEmailResultToClient = this.navParams.get('isEmailResultToClient')
    }
    

  }

  ionViewDidLoad(){
    //to check if the user has refreshed the page
    if (this.assessmentsArray == undefined) {
      localStorage.clear();
      this.navCtrl.setRoot('login');
    } else {
      this.numberOfAssessments = this.assessmentsArray.length;
      this.getAssessmentQuestions();
    }
  }

  getAssessmentQuestions() {
      if (this.index + 1 <= this.assessmentsArray.length) {
        var assessment = this.assessmentsArray[this.index];
        var assessmentId;
        this.index_ = this.index + 1;
        if (this.isSchedule) {
          assessmentId = assessment;
        }
        else {
          assessmentId = assessment.id
        }
        this.items.getAssessmentQuestions(assessmentId, this.uniqueId).subscribe(
          data => {
            this.questions = data.assessment;
            this.assessmentName = data.assessment.extended_name;
            this.isenabled = true;
          },
          err => {
            console.log(err);
          },

        );
      }
      else {
        this.assessmentCompleted = true;
        //this.navCtrl.push('assessment-complete');
        //this.navCtrl.getActive().data.pageId = "administer";
      }
  }

  // getText(){
  //   // this.navCtrl.getActive().data.pageId = "administer";
  //   return "Thank you for completing the assessment";
  // }

  administer() {
    if (this.isSchedule) {
      this.navCtrl.push('test-questions',
        {
          clientName: this.clientName,
          assessmentsArray: this.assessmentsArray,
          data: this.questions,
          uuId: this.uniqueId,
          index: this.index,
          isEmailResultToClient: this.isEmailResultToClient,
          reports: this.reportsArray,
          assessmentName: this.assessmentName
          //callback: this.getData
        });

    } else {
      // this.navCtrl.getActive().data.pageName = "testPage";
      this.navCtrl.push('test-questions',
        {
          clientName: this.clientName,
          assessmentsArray: this.assessmentsArray,
          data: this.questions,
          clientId: this.clientId,
          is_parent_2: this.is_parent_2,
          index: this.index
          //callback: this.getData
        });
    }
  }
  //removed this callback and push directly to test-questions page and from there either call administer or assessment complete
  //this method gets called from test-questions.ts as part of callback
  // getData = (data) => {
  //   return new Promise((resolve, reject) => {
  //     if (this.index + 1 <= this.assessmentsArray.length) {
  //       this.index = this.index + 1;
  //       this.isenabled = false;
  //       this.getAssessmentQuestions();
  //       resolve();
  //     }
  //   });
  // };

  cancel() {
    let prompt = this.alertCtrl.create({
      title: 'Enter Password',
      message: "Please enter the password to exit assessment",
      inputs: [
        {
          name: 'password',
          placeholder: 'password',
          type: 'password'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
          }
        },
        {
          text: 'Exit',
          handler: data => {
            if (data.password === localStorage.getItem('password')) {
              this.navCtrl.push('clients', { clientId: this.clientId });
            } else {
              let toast = this.toastCtrl.create({
                message: 'The password is incorrect',
                duration: 3000,
                position: 'top'
              });
              toast.present();
            }

          }
        }
      ]
    });
    prompt.present();
  }



}



// WEBPACK FOOTER //
// ./src/pages/administer/administer.ts